module.exports = __webpack_public_path__ + "static/img/detail_fy02.166bff2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/detail_fy02.png
// module id = IOAh
// module chunks = 19